/* eslint-disable no-bitwise */
import { onError } from '@apollo/client/link/error';

const handleErrors = (onGraphQLError, onNetworkError) => onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      onGraphQLError(graphQLErrors);
    }
    if (networkError) {
      onNetworkError(networkError);
    }
  });

export default handleErrors;
